"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var get_1 = __importDefault(require("lodash/get"));

var prop_types_1 = require("prop-types");

require("./index.css");

var AppBanner = function (_a) {
  var showBanner = _a.showBanner,
      dataTestId = _a.dataTestId,
      children = _a.children;
  var ref = (0, react_1.useRef)(null);

  var sizeAppBannerSpacer = function () {
    var height = (0, get_1.default)(ref, 'current.clientHeight', 0);
    global.document.documentElement.style.setProperty('--app-banner-height-offset', height + "px");
  };

  (0, react_1.useLayoutEffect)(function () {
    sizeAppBannerSpacer();
    global.window.addEventListener('resize', sizeAppBannerSpacer);
    return function () {
      global.window.removeEventListener('resize', sizeAppBannerSpacer);
    };
  });
  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: "app-banner",
    "data-testid": dataTestId
  }, {
    children: showBanner && (0, jsx_runtime_1.jsx)("div", __assign({
      ref: ref,
      "data-testid": dataTestId + "-content",
      className: "app-banner-content"
    }, {
      children: children
    }), void 0)
  }), void 0);
};

AppBanner.propTypes = {
  showBanner: prop_types_1.bool,
  dataTestId: prop_types_1.string,
  children: prop_types_1.node
};
AppBanner.defaultProps = {
  showBanner: false,
  dataTestId: 'app-banner-container',
  children: undefined
};
exports.default = AppBanner;